<template>
    <div class="book-preview-container">
        <div ref="bookContainer" class="ebook-container">
        </div>
        <!-- 底部固定菜单 -->
        <div class="bottom-menu">
            <div class="bottom-menu-item">
                <div class="bottom-menu-item-title" @click="showNavigation">
                    <svg-icon icon-class="menu"></svg-icon>
                </div>
            </div>
            <!-- 设置字体大小 输入框+A-A+按钮 -->
            <div class="bottom-menu-item">
                <div class="bottom-menu-item-input">
                    <div class="bottom-menu-item-input-title">
                        <svg-icon v-if="fontSize > 12" color=" #2C2C2E " icon-class="font-1"
                            @click="handleChange(fontSize - 2)"></svg-icon>
                        <svg-icon v-else color="#eeeeee" icon-class="font-1"
                            @click="handleChange(fontSize - 2)"></svg-icon>
                        <span>{{ fontSize > 12 ? fontSize - 2 : '' }}</span>
                        <span class="active">{{ fontSize }}</span>
                        <span>{{ fontSize < 40 ? fontSize + 2 : '' }}</span>
                        <svg-icon v-if="fontSize < 40" color="#2C2C2E" icon-class="font-2"
                            @click="handleChange(fontSize + 2)"></svg-icon>
                        <svg-icon v-else color="#eeeeee" icon-class="font-2"
                            @click="handleChange(fontSize + 2)"></svg-icon>
                    </div>
                </div>
            </div>
            <!-- 夜间模式 -->
            <div class="bottom-menu-item">
                <div class="bottom-menu-item-title" @click="handleNightMode">{{ themeList[defaultTheme].name }}</div>
            </div>
        </div>
        <!-- 目录 -->
        <el-drawer class="book-menu-drawer" width="80%" :modal="false" :visible.sync="navigationVisible" direction="ltr"
            :before-close="handleClose">
            <div class="navigation-container">
                <div class="navigation-item" v-for="item in navigation" :key="item.id">
                    <div class="navigation-item-title" @click="goToPage(item.id)">{{ item.label }}</div>
                </div>
            </div>
        </el-drawer>
        <!-- <div class="controls">
            <button @click="prevPage">上一页</button>
            <button @click="nextPage">下一页</button>
        </div> -->
    </div>
</template>

<script>
import { mapState } from "vuex";

import ePub from 'epubjs';
import { getMagazineDetails, saveProgressFun, getProgressFun } from "@/assets/api/magazine.js";
import { flatten } from '@/utils/book'

export default {
    data() {
        return {
            // 新增触摸起始坐标存储
            touchStartY: 0,
            isSwiping: false,
            swipeThreshold: 50,
            swipeEnabled: true,
            bookId: '',
            book: null,
            rendition: null,
            // 本地书籍路径（放在public/epubs目录下）
            // bookPath: 'static/9787510823824.epub',
            bookPath: '',
            // 或使用在线URL
            // bookPath: 'https://example.com/book.epub'
            startX: 0,
            startY: 0,
            progress: 0,//进度
            navigation: [],
            navigationVisible: false,
            fontSize: 14,
            defaultTheme: 0, //默认主题设置
            themeList: [//主题选项
                {
                    name: '默认',
                    style: {
                        body: {
                            'color': '#000',
                            'background': '#fff',
                        },
                    }
                },

                {
                    name: '护眼',
                    style: {
                        body: {
                            'color': '#000',
                            'background': '#cddabc'
                        }
                    }
                },
                {
                    name: '夜间',
                    style: {
                        body: {
                            'color': '#fff',
                            'background': '#232323'
                        }
                    }
                },
                {
                    name: '金色',
                    style: {
                        body: {
                            'color': '#000',
                            'background': '#f0edd8'
                        }
                    }
                }
            ],
        };
    },
    created() {
        this.bookId = localStorage.getItem('bookId')

    },
    computed: {
        ...mapState(['userInfo'])
    },
    mounted() {
        getMagazineDetails(this.bookId).then((res) => {
            // console.log(res.data)
            this.bookPath = res.data.data.attachment ? this.$imgUrl + res.data.data.attachment : ''
            this.initializeBook()
        });
        // this.initializeBook();
        // 全局监听 touchmove 事件
        document.addEventListener('touchmove', this.preventScroll, { passive: false });
        // 全局监听 touchstart 事件
        this.$refs.bookContainer.addEventListener('touchstart', this.handleTouchStart, { passive: false });
        //监听页面关闭
        window.addEventListener('beforeunload', this.saveProgress);
    },
    beforeDestroy() {
        this.saveProgress()
        this.destroyBook();
        // 移除全局监听
        document.removeEventListener('touchmove', this.preventScroll);
        // 移除全局监听
        this.$refs.bookContainer.removeEventListener('touchstart', this.handleTouchStart);
    },
    methods: {
        saveProgress() {
            saveProgressFun({
                "userId": this.userInfo.userId,
                "mgzId": this.bookId,
                "pageNum": this.progress
            }).then((res) => {
                console.log(res)
            })
        },
        initializeBook() {
            // console.log(this.bookPath)
            // 创建Book实例
            this.book = ePub(this.bookPath);

            // 渲染到DOM
            this.rendition = this.book.renderTo(this.$refs.bookContainer, {
                width: innerWidth,   // window.innerHeight
                height: innerHeight,
                method: 'default',
                manager: "continuous",
                flow: "scrolled",
                spread: true
            });
            this.setTheme()
            //获取进度
            getProgressFun({
                "userId": this.userInfo.userId,
                "mgzId": this.bookId
            }).then((res) => {
                // console.log(res)
                this.progress = res.data.data.pageNum
                this.rendition.display(this.progress)
            })
            // 显示内容
            this.rendition.display().then(() => {
                // alert('EPUB加载完成');
                this.book.loaded.navigation.then(nav => {
                    const navItem = flatten(nav.toc) // 导航数组扁平化
                    console.log(nav.toc)
                    function find(item, level = 0) { // 添加level表示目录层级，顶层：0
                        return !item.parent ? level : find(navItem.filter(parentItem =>
                            parentItem.id === item.parent)[0], ++level) // parent指向父级id, 若没有则1为undefined
                    }
                    // 目的是给扁平化后的数组添加一个level表示层级，parent为undefined则为顶级（只有1级目录），
                    // 如果有则说明其有子目录，那么递归向下的加level
                    navItem.forEach(item => {
                        item.level = find(item)
                    })
                    this.navigation = navItem // for vuex
                    // console.log(this.navigation)
                })
                this.rendition.on('locationChanged', (e) => {
                    // console.log('locationChanged', e)
                    this.progress = e.index
                })

            }).catch(error => {
                console.error('EPUB加载失败', error);
                // alert('EPUB加载失败');
            });

            // 可选：键盘导航
            window.addEventListener('keyup', this.handleKeyPress);
        },
        nextPage() {
            this.rendition && this.rendition.next();
        },
        prevPage() {
            this.rendition && this.rendition.prev();
        },
        handleKeyPress(event) {
            if (event.keyCode === 37) this.prevPage(); // 左箭头
            if (event.keyCode === 39) this.nextPage(); // 右箭头
        },
        destroyBook() {
            if (this.rendition) {
                this.rendition.destroy();
                this.rendition = null;
            }
            if (this.book) {
                this.book.destroy();
                this.book = null;
            }
            window.removeEventListener('keyup', this.handleKeyPress);
        },
        // 新增触摸处理方法
        handleTouchStart(e) {
            // alert('Touch start detected');
            if (e.touches.length > 1 || !this.swipeEnabled) return;
            this.isSwiping = true;
            this.touchStartY = e.touches[0].clientY;
            this.startX = e.touches[0].clientX;
            this.startY = e.touches[0].clientY;
        },
        handleTouchEnd(e) {
            if (!this.isSwiping) return;
            this.isSwiping = false;

            const endY = e.changedTouches[0].clientY;
            const deltaY = this.touchStartY - endY;

            if (Math.abs(deltaY) > this.swipeThreshold) {
                deltaY < 0 ? this.nextPage() : this.prevPage();
            }
        },
        handleTouchCancel() {
            this.isSwiping = false;
        },
        handleTouchMove(event) {
            // 禁用页面弹动
            event.preventDefault();
        },
        goToNextPage() {
            // 使用 Vue Router 导航到下一页
            this.$router.push('/next-page'); // 替换为实际的路由路径
        },
        goToPreviousPage() {
            // 使用 Vue Router 导航到上一页
            this.$router.push('/previous-page'); // 替换为实际的路由路径
        },
        preventScroll(event) {
            event.preventDefault();
        },
        showNavigation() {
            this.navigationVisible = true;
        },
        handleClose() {
            this.navigationVisible = false;
        },
        goToPage(id) {
            console.log(id)
            //去掉navPoint-
            const pageId = id.replace('navPoint-', '')
            this.rendition.display(pageId)
            this.navigationVisible = false;
        },
        handleChange(value) {
            // 设置字体大小,最大40px,最小14px
            if (value > 40) {
                value = 40
            } else if (value < 12) {
                value = 12
            }
            // 设置字体大小
            this.rendition.themes.fontSize(value + 'px')
            this.fontSize = value
        },
        handleNightMode() {
            //点击切换主题
            this.defaultTheme = this.defaultTheme + 1
            if (this.defaultTheme >= this.themeList.length) {
                this.defaultTheme = 0
                this.setTheme()
            }
            this.setThemeSave(this.defaultTheme)

        },
        setTheme() {
            this.themeList.forEach(element => {
                this.rendition.themes.register(element.name, element.style)
            })
        },
        //选择主题后保存
        setThemeSave(index) {
            this.rendition.themes.select(this.themeList[index].name)
        },
    }
};
</script>

<style scoped>
.book-preview-container {
    position: relative;
    width: 100%;
    height: calc(100vh - 120px);
}

.ebook-container {
    height: 100%;
    /* padding: 20px 0; */
}

.controls {
    margin-top: 10px;
    text-align: center;
}

.epub-container::-webkit-scrollbar {
    display: none;
}

/* 添加触摸优化样式 */
.ebook-container {
    touch-action: pan-y;
    /* 保留垂直滚动能力 */
    overflow: hidden;
    /* 防止容器内出现滚动条 */
    -webkit-overflow-scrolling: touch;
    /* iOS平滑滚动 */
}

.ebook-container {
    transition: transform 0.3s ease;
}

.page-slide-enter {
    transform: translateY(100%);
}

.page-slide-leave-to {
    transform: translateY(-100%);
}

/* 禁用滚动条 */
html,
body {
    /* overflow: hidden; */
}

/* 确保元素可以接收触摸事件 */
.touch-area {
    touch-action: manipulation;
}

.bottom-menu {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: #fff;
    padding: 20px;
    border-top: 1px solid #e5e5e5;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.bottom-menu-item-title {
    font-size: 16px;
    font-weight: bold;
    /* text-align: center; */
    width: fit-content;

}

.bottom-menu-item-title .svg-icon {
    font-size: 26px;
}

.navigation-container {
    /* position: fixed; */
    top: 0;
    left: 0;
    right: 0;
    background-color: #fff;
}

.navigation-item {
    flex: 1;
    padding: 10px 20px;
    /* text-align: center; */
    cursor: pointer;
}

.navigation-item-title {
    font-size: 14px;
}

.bottom-menu-item-input-title {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-weight: bold;
    color: #2C2C2E;
    line-height: 21px;
    text-align: left;
    font-style: normal;
    background: #F8F8F8;
    border-radius: 4px;
    padding: 4px;

    .svg-icon {
        width: 36px;
        height: 36px;
        font-size: 26px;
        border-radius: 4px;
        padding: 0 8px;
        cursor: pointer;
        margin: 0 4px;
    }

    span {
        width: 18px;
        font-size: 14px;
        font-weight: bold;
        color: rgba(44, 44, 46, 0.5);
        line-height: 21px;
        margin: 0 10px;
    }

    .active {
        font-size: 16px;
        color: #2C2C2E;
        line-height: 21px;
        margin: 0 10px;
    }
}
</style>
<style>
.book-menu-drawer .el-drawer {
    /* width: 80%!important; */
    height: 94% !important;
    box-shadow: none;
}
</style>


// WEBPACK FOOTER //
// src/views/book-preview/index.vue